import type { JournalListItemDTO } from '~/shared/api/client/journals/journals.dto';

/**
 * Which issue is being bought right now. The state is shared rather than local
 * because the buy button stands in three different places — the hero, a card
 * deep inside the grid and the issue page — while the modal is mounted once,
 * at the root of the section
 */
export function useJournalOrder() {
  const issue = useState<JournalListItemDTO | null>(
    'journal-order-issue',
    () => null,
  );

  const isOpen = computed(() => issue.value !== null);

  const open = (value: JournalListItemDTO) => {
    issue.value = value;
  };

  const close = () => {
    issue.value = null;
  };

  return { issue, isOpen, open, close };
}
